import { Box, Divider, Grid, IconButton, Paper, Typography } from '@mui/material';
import SearchBar from '../SearchBar';
import { KeyboardDoubleArrowRight } from '@mui/icons-material';
import { getSolicitacoes, Solicitacao } from '../../services/solicitacoesService';
import { useEffect, useState } from 'react';
import CircularIndeterminate from '../CircularProgress';
import { Link } from 'react-router-dom';
import { fetchUserAttributes } from 'aws-amplify/auth';

const columns = [
  { title: "Pendente", color: "#FFC000" },
  { title: "Em andamento", color: "#FFD54F" },
  { title: "Concluída", color: "#8FD51D" },
  { title: "Cancelada", color: "#FF5050" }
];

const Kanban = () => {
  const [solicitacoes, setSolicitacoes] = useState<Solicitacao[]>([]);
  const [filteredSolicitacoes, setFilteredSolicitacoes] = useState<Solicitacao[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    const fetchData = async () => {
        try {
            const userAttributes = await fetchUserAttributes();
            const userEmail = userAttributes.email; // Obtém o email do usuário
            //console.log('User Email:', userEmail); // Log do email do usuário
            const userGroup = userAttributes['custom:group']; // Obtém o grupo do usuário

            const data = await getSolicitacoes();
            //console.log('Solicitacoes:', data); // Log das solicitações

            // Filtra solicitações pelo email do usuário
            const filteredData = data.filter(solicitacao => solicitacao.email === userEmail || userGroup === 'ADMINS');
            //console.log('Filtered Data:', filteredData); // Log dos dados filtrados

            // Filtra novamente com base no texto de pesquisa
            const finalFilteredData = searchText === ''
                ? filteredData
                : filteredData.filter(solicitacao =>
                    solicitacao.n_solicitacao.toLowerCase().includes(searchText.toLowerCase()) ||
                    solicitacao.objetivo.toLowerCase().includes(searchText.toLowerCase())
                );

            setSolicitacoes(data);
            setFilteredSolicitacoes(finalFilteredData); // Define as solicitações filtradas
        } catch (error) {
            console.error('Failed to fetch solicitacoes or user attributes', error);
        } finally {
            setLoading(false);
        }
    };

    fetchData();
}, [searchText]); // Adicione searchText como dependência


  const getStatusColumn = (status: any) => {
    switch (status) {
      case 1: return "Pendente";
      case 2: return "Em andamento";
      case 4: return "Concluída";
      case 5: return "Concluída";
      default: return "Cancelada";
    }
  };

  const formatDate = (dateString: string) => {
    const [ano, mes, dia] = dateString.split('-');
    return `${dia}/${mes}/${ano}`;
  };

  if (loading) {
    return <CircularIndeterminate />;
  }

  return (
    <Box sx={{ flexGrow: 1, paddingLeft: 5, paddingRight: 5, paddingTop: 3, paddingBottom: 3 }}>
      <Grid container marginRight={2} marginBottom={2} spacing={2} justifyContent="right">
        <SearchBar onSearch={(value) => setSearchText(value)} />
      </Grid>
      <Grid container spacing={4}>
        {columns.map((column) => (
          <Grid item xs={12} xl={3} lg={3} key={column.title}>
            <Paper variant='outlined' sx={{ borderTopLeftRadius: '30px', borderTopRightRadius: '30px', borderBottomRadius: '20px', minHeight: '100vh' }}>
              <Typography 
                variant="h6" 
                color="white" 
                sx={{ backgroundColor: column.color, borderTopRightRadius: '20px', borderTopLeftRadius: '20px', textAlign: 'center', padding: 1 }}
              >
                {column.title}
              </Typography>
              {filteredSolicitacoes
                .filter(solicitacao => getStatusColumn(solicitacao.status) === column.title)
                .map(solicitacao => (
                  <Paper elevation={2} key={solicitacao.id} sx={{ padding: 2, margin: 1 }}>
                    <Typography variant="body1"><strong>{solicitacao.n_solicitacao}</strong> | Data: {formatDate(solicitacao.data_solicitacao)}</Typography>
                    <Typography variant="subtitle2" marginTop={1}><strong>Objetivo: </strong>{solicitacao.objetivo}</Typography>
                    <Divider sx={{ marginTop: 2, marginBottom: 2 }} />
                    <Grid container item direction='row' justifyContent="space-between">
                      <Grid item xs={10} alignContent="center" >
                        <Typography variant="body2">Projeto: {solicitacao.projeto}</Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Link to={`detalhes/${solicitacao.id}`}>
                          <IconButton color='primary'>
                            <KeyboardDoubleArrowRight />
                          </IconButton>
                        </Link>
                      </Grid>
                    </Grid>
                  </Paper>
                ))}
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Kanban;
